package com.exura.components.loading

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent

val DoubleHeartbeatSpin = Keyframes {
    0.percent { Modifier.scale(1).rotate(0.deg) }
    10.percent { Modifier.scale(1.15).rotate(0.deg) }
    20.percent { Modifier.scale(1).rotate(0.deg) }
    30.percent { Modifier.scale(1.15).rotate(0.deg) }
    40.percent { Modifier.scale(1).rotate(0.deg) }

    100.percent { Modifier.scale(1).rotate(360.deg) }
}
